module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/lines/wall/textures/bricks-normal.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/lines/wall/textures/bricks-normal.jpg
// module id = 466
// module chunks = 0